import { Box, Stack, Typography } from '@mui/material';
import { getRefundsTotal } from 'pages/payments/transactions/transactions.utils';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'util/currency';

const RefundTotalInfo = ({ refunds = [], currency, chargeAmount }) => {
  const { t } = useTranslation();

  if (refunds.length === 0) return null;

  const total = getRefundsTotal(refunds);

  const refundTotals = [
    {
      value: formatCurrency(-total, currency),
      description: t('drawer.refundDrawer.refundsTotal', {
        num: refunds.length,
      }),
    },
    {
      value: formatCurrency(chargeAmount - total, currency),
      description: t('drawer.refundDrawer.refundableAmount'),
    },
  ];

  return (
    <Stack spacing={1}>
      {refundTotals.map(({ value, description }, index) => (
        <Box display="flex" justifyContent="space-between" key={index}>
          <Typography sx={{ fontWeight: 'bold' }}>{description}</Typography>
          <Typography sx={{ fontWeight: 'bold' }}>{value}</Typography>
        </Box>
      ))}
    </Stack>
  );
};

export default RefundTotalInfo;
